import { getMonthName } from './utils/dateUtils';
import { useColumnWidths } from './useColumnWidths';

const CashFlowHeader = ({ cashFlowData, columns, startResize }) => {
  const { columnWidths, getWidth, startResize: startResizeDesc } = useColumnWidths();

  const getCol = (name) => columns.find(c => c.name === name);

  const descriptionCol     = getCol("Description");
  const forecastAllocationCol  = getCol("For. Allocation");
  const forecastHoursCol       = getCol("For. Hours");
  const actualHoursCol         = getCol("Act. Hours");
  const ForecastHvCol       = getCol("For. HV");
  const forecastHCostCol       = getCol("For. h. Cost");
  const forecastHBillCol       = getCol("For. h. Bill");
  const forecastTotalCostCol   = getCol("For. Total Cost");
  const forecastTotalBillCol   = getCol("For. Total Bill");
  const forecastCvCol          = getCol("For. CV");
  const forecastGpCol           = getCol("For. GP");
  const invCol                 = getCol("INV");
  const acCol                  = getCol("AC");
  const gpCol                  = getCol("GP");
  const totalsCol              = getCol("Totals");

  const w = (colName) => ({ width: columnWidths[colName] ?? getWidth(colName), minWidth: columnWidths[colName] ?? getWidth(colName), flexShrink: 0 });

  const labelWithHandle = (colName, label, className = "forecast-label") => (
    <span className={className} style={w(colName)}>
      {label}
      {/* <span className="resize-handle" onMouseDown={(e) => startResize(colName, e)} /> */}
    </span>
  );

  return (
    <thead>
      <tr>
        <th className="category-column-header">Category</th>
        {descriptionCol?.isVisible !== false && (
          <th className="description-column-header" style={{ width: columnWidths['Description'] ?? getWidth('Description'), minWidth: columnWidths['Description'] ?? getWidth('Description') }}>
            {descriptionCol?.customName || descriptionCol?.name || "Description"}
            <span className="resize-handle" onMouseDown={(e) => startResizeDesc('Description', e)} />
          </th>
        )}
        {cashFlowData.map(cf => (
          <th key={`${cf.year}-${cf.month}`} className="month-column">
            <div className="month-header">
              <span className="month-name">{getMonthName(cf.month)}</span>
            </div>
            <div className="in-out-header">
              {forecastAllocationCol?.isVisible  && labelWithHandle("For. Allocation",  forecastAllocationCol.customName  || "For. Allocation")}
              {forecastHoursCol?.isVisible       && labelWithHandle("For. Hours",       forecastHoursCol.customName       || "For. Hours")}
              {actualHoursCol?.isVisible         && labelWithHandle("Act. Hours",       actualHoursCol.customName         || "Act. Hours")}
              {ForecastHvCol?.isVisible       && labelWithHandle("For. HV",       ForecastHvCol.customName       || "For. HV")}
              {forecastHCostCol?.isVisible       && labelWithHandle("For. h. Cost",     forecastHCostCol.customName       || "For. h. Cost")}
              {forecastHBillCol?.isVisible       && labelWithHandle("For. h. Bill",     forecastHBillCol.customName       || "For. h. Bill")}
              {forecastTotalCostCol?.isVisible   && labelWithHandle("For. Total Cost",  forecastTotalCostCol.customName   || "For. Total Cost")}
              {forecastTotalBillCol?.isVisible   && labelWithHandle("For. Total Bill",  forecastTotalBillCol.customName   || "For. Total Bill")}
              {invCol?.isVisible                 && labelWithHandle("INV",              invCol.customName  || invCol.name,  "in-label")}
              {acCol?.isVisible                  && labelWithHandle("AC",               acCol.customName   || acCol.name,   "out-label")}
              {forecastCvCol?.isVisible          && labelWithHandle("For. CV",          forecastCvCol.customName          || "For. CV")}
              {forecastGpCol?.isVisible          && labelWithHandle("For. GP",          forecastGpCol.customName          || "For. GP",  "gp-label")}
              {gpCol?.isVisible                  && labelWithHandle("GP",               gpCol.customName   || gpCol.name,   "gp-label")}
            </div>
          </th>
        ))}
        {totalsCol?.isVisible !== false && (
          <th className="totals-column">
            <div className="month-header">
              <span className="month-name">{totalsCol?.customName || "Totals"}</span>
            </div>
            <div className="in-out-header">
              {forecastAllocationCol?.isVisible  && labelWithHandle("For. Allocation",  forecastAllocationCol.customName  || "For. Allocation")}
              {forecastHoursCol?.isVisible       && labelWithHandle("For. Hours",       forecastHoursCol.customName       || "For. Hours")}
              {actualHoursCol?.isVisible         && labelWithHandle("Act. Hours",       actualHoursCol.customName         || "Act. Hours")}
              {ForecastHvCol?.isVisible       && labelWithHandle("For. HV",       ForecastHvCol.customName       || "For. HV")}
              {forecastHCostCol?.isVisible       && labelWithHandle("For. h. Cost",     forecastHCostCol.customName       || "For. h. Cost")}
              {forecastHBillCol?.isVisible       && labelWithHandle("For. h. Bill",     forecastHBillCol.customName       || "For. h. Bill")}
              {forecastTotalCostCol?.isVisible   && labelWithHandle("For. Total Cost",  forecastTotalCostCol.customName   || "For. Total Cost")}
              {forecastTotalBillCol?.isVisible   && labelWithHandle("For. Total Bill",  forecastTotalBillCol.customName   || "For. Total Bill")}
              {invCol?.isVisible                 && labelWithHandle("INV",              invCol.customName  || invCol.name,  "in-label")}
              {acCol?.isVisible                  && labelWithHandle("AC",               acCol.customName   || acCol.name,   "out-label")}
              {forecastCvCol?.isVisible          && labelWithHandle("For. CV",          forecastCvCol.customName          || "For. CV")}
              {forecastGpCol?.isVisible          && labelWithHandle("For. GP",          forecastGpCol.customName          || "For. GP",  "gp-label")}
              {gpCol?.isVisible                  && labelWithHandle("GP",               gpCol.customName   || gpCol.name,   "gp-label")}
            </div>
          </th>
        )}
      </tr>
    </thead>
  );
};

export default CashFlowHeader;